window.$ = window.jQuery = require('jquery');

require('jquery-viewport-checker');
//require('bootstrap');
//require('leaflet');
//require('slick-carousel');
//require("./simple-lightbox");